import React from 'react';
import {Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles'

const useStyles=makeStyles((theme)=>({
    textColor: {
        color:"#ffffff",
    },
    textMain:{
        fontWeight: "700",
        fontSize: "6rem",

        [theme.breakpoints.down(1500)]: {
            marginTop: "2rem",
            fontSize: "5rem",
          },
          [theme.breakpoints.down(1210)]: {
            marginTop: "4rem",
            fontSize: "4.5rem",
          },
          [theme.breakpoints.down(1100)]: {
            fontSize: "4rem",
          },
          [theme.breakpoints.down(970)]: {
            fontSize: "3.5rem",
          },
          [theme.breakpoints.down(845)]: {
            fontSize: "3rem",
          },
          [theme.breakpoints.down(730)]: {
            fontSize: "2.5rem",
          }
    },
    textSecondary: {
        fontWeight: "500",

        [theme.breakpoints.down(1500)]: {
            fontSize: "3rem",
          },
        [theme.breakpoints.down(1100)]: {
        fontSize: "2.5rem",
        },
        [theme.breakpoints.down(970)]: {
            fontSize: "2rem",
          },
        [theme.breakpoints.down(730)]: {
        fontSize: "2rem",
        },
    },
    textTertiary : {
        [theme.breakpoints.down(1200)]: {
            fontSize: "1.1rem",
          },
          [theme.breakpoints.down(870)]: {
            fontSize: "0.9rem",
          },
    },
    button : {
        whiteSpace: "nowrap",
        marginBottom: "0",

        [theme.breakpoints.down(960)]: {
            fontSize: "0.8rem",
          },
          [theme.breakpoints.down(400)]: {
            fontSize: "0.7rem",
          },
    },
    body1 : {
        fontSize: "1.2rem",

        [theme.breakpoints.down('md')]: {
            fontSize: "1rem",
            textAlign: "center",
          },
    },
    sectionHeading: {
        fontWeight: "700",
        color: "#eec653",
        display: 'flex',
        margin: '5rem auto 1rem auto',

        [theme.breakpoints.down('md')]: {
            fontSize: "3rem",
            margin: '2rem auto',
          },
        [theme.breakpoints.down('sm')]: {
        fontSize: "2.5rem",
        margin: '2rem auto',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: "1.8rem",
            margin: '1.5rem auto',
        },
        [theme.breakpoints.down(500)]: {
            fontSize: "1.5rem",
            },
    
        '&::before, &::after': {
            content: '""',
            height: "1px",
            flex: "1 1",
            borderBottom: "2px solid #a9a9a9",
            margin: "auto",
            width: 200,

            [theme.breakpoints.down('md')]: {
                width: 150,
              },
            [theme.breakpoints.down('sm')]: {
            width: 100,
            },
            [theme.breakpoints.down('xs')]: {
                width: 70,
            },
            [theme.breakpoints.down(500)]: {
                width: 50,
            },
          },
          '&::before': {
              marginRight: "1rem"
          },
          '&::after': {
            marginLeft: "1rem"
        },
    }

}));


export const Heading1 = ({children}) => {
    const classes=useStyles();
    return <Typography className={`${classes.textMain} ${classes.textColor}`} variant="h1" component="h2">{children}</Typography>
}

export const Heading2 = ({children}) => {
    const classes=useStyles();
    return <Typography className={`${classes.textSecondary} ${classes.textColor}`} variant="h2" gutterBottom>{children}</Typography>
}

export const Heading3 = ({children}) => {
    const classes=useStyles();
    return <Typography className={classes.sectionHeading} variant="h3" gutterBottom>{children}</Typography>
}

export const Heading4 = ({children, ...restProps}) => {
    return <Typography {...restProps}>{children}</Typography>
}

export const Heading5 = ({children}) => {
    const classes=useStyles();
    return <Typography className={`${classes.textTertiary} ${classes.textColor}`} variant="h5" gutterBottom>{children}</Typography>
}

export const Heading6 = ({children, ...restProps}) => {
    return <Typography {...restProps}>{children}</Typography>
}

export const SubTitle1 = ({children}) => {
    return <Typography variant="subtitle1" gutterBottom>{children}</Typography>
}

export const SubTitle2 = ({children}) => {
    return <Typography variant="subtitle2" gutterBottom>{children}</Typography>
}

export const Body1 = ({children}) => {
    const classes=useStyles();
    return <Typography className={classes.body1} variant="body1" gutterBottom>{children}</Typography>
}

export const Body2 = ({children, ...restProps}) => {
    return <Typography {...restProps}>{children}</Typography>
}

export const ButtonText = ({children}) => {
    const classes=useStyles();
    return <Typography className={classes.button} variant="button" display="block" gutterBottom>{children}</Typography>
}